export default {
    setDtpQueries(state, data) {
        state.dtpQueries = data
    },
    setSelectedQueryProject(state, project) {
        state.selectedQueryProject = project
    },
    setSelectedQuerySite(state, site) {
        state.selectedQuerySite = site
    },
    setQueryData(state, queryData) {
        state.searchQueryData = queryData
    },
    setQueryDataSites(state, queryData) {
        state.searchQueryDataSites = queryData
    },
    setReport(state, report) {
        state.report = report
    },
    mergeUpdatedDtpQueries(state, newData) {
        const updates = new Map(newData.map(item => [item._id, item]));

        state.dtpQueries = state.dtpQueries.map(siteGroup => {
            const hasUpdates = siteGroup.queries.some(q => updates.has(q._id));

            if (!hasUpdates) return siteGroup;
            const updatedQueries = siteGroup.queries.map(originalQuery => {
                const update = updates.get(originalQuery._id);

                if (update) {
                    return {
                        ...originalQuery,
                        ...update,
                        projectName: originalQuery.projectName,
                        siteName: originalQuery.siteName
                    };
                }

                return originalQuery;
            });

            return {
                ...siteGroup,
                queries: updatedQueries
            };
        });
    }
}
